import React, { useState, useCallback } from 'react';

const CampusFilters = ({ onSearchChange, onDateRangeChange, searchValue, dateRangeValue }) => {
  const [localSearch, setLocalSearch] = useState(searchValue || '');
  const [localDateRange, setLocalDateRange] = useState(dateRangeValue || '1w');

  const handleSearchChange = useCallback((e) => {
    const value = e.target.value;
    setLocalSearch(value);
    if (onSearchChange) {
      onSearchChange(value);
    }
  }, [onSearchChange]);

  const handleDateRangeChange = useCallback((e) => {
    const value = e.target.value;
    setLocalDateRange(value);
    if (onDateRangeChange) {
      onDateRangeChange(value);
    }
  }, [onDateRangeChange]);

  return (
    <div className="card border rounded-3 shadow-sm mb-4">
      <div className="card-body p-4">
        <div className="row g-3 align-items-center">
          <div className="col-12 col-lg-6">
            <div className="position-relative">
              <i className="bi bi-search position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}></i>
              <input
                type="text"
                className="form-control ps-5"
                placeholder="Search campuses..."
                value={localSearch}
                onChange={handleSearchChange}
                style={{
                  height: '48px',
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: '0.5rem'
                }}
              />
            </div>
          </div>
          <div className="col-12 col-lg-3">
            <div className="position-relative">
              <i className="bi bi-calendar-event position-absolute" style={{ left: '16px', top: '50%', transform: 'translateY(-50%)', color: '#64748b' }}></i>
              <select
                className="form-select ps-5"
                value={localDateRange}
                onChange={handleDateRangeChange}
                style={{
                  height: '48px',
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: '0.5rem'
                }}
              >
                <option value="1d">Last 1 day</option>
                <option value="1w">Last 1 week</option>
                <option value="1m">Last 1 month</option>
                <option value="6m">Last 6 months</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampusFilters;

